/**
 * Mathematical constants - removes magic numbers from config
 */

export const MATH = {
  /** Convert degrees to radians: angle * DEG_TO_RAD */
  DEG_TO_RAD: Math.PI / 180,

  /** Convert radians to degrees: angle * RAD_TO_DEG */
  RAD_TO_DEG: 180 / Math.PI,

  /** Full circle in radians: 2π */
  TWO_PI: Math.PI * 2,

  /** Quarter circle in radians: π/2 (90 degrees) */
  HALF_PI: Math.PI / 2,

  /** Eighth circle in radians: π/4 (45 degrees) */
  QUARTER_PI: Math.PI / 4,
} as const;
